<!-- Forgot Password -->
<section *ngIf="!passwordReset">
    <div class="container content-box">

        <!-- Title -->
        <h2 class="text-center">Forgot Password?</h2>
        <p class="text-center">You can reset your password here.</p>

        <!-- Forgot Password Form -->
        <form name="form" class="" (submit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>

            <!-- Email -->
            <label class="required-field">Email</label>
            <input type="email" id="email" class="form-control mb-2" placeholder="Email" [(ngModel)]="user.email" #email="ngModel" name="email" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" email required>

            <!-- Invalid Email-->
            <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                <div class="mb-1 text-center" *ngIf="email.errors!.required">Email is required</div>
                <div class="mb-1 text-center" *ngIf="email.errors!.email">Email must be a valid email address</div>
            </div>

            <!-- Submit Button -->
            <div class="text-center">
                <button type="submit" class="btn waves-dark text">Reset Password</button>
            </div>
        </form>
    </div>
</section>

<!-- Display Confirmation-->
<section *ngIf="passwordReset">
    <div class="container content-box text-center">
        <p style="margin: 0;">If it exists, we have sent an email to "{{user.email}}" with instructions to reset your password. Make sure to check your spam folder if you do not see it.</p>
    </div>

    <!-- Back to Login-->
    <div class="container text-center">
        <button class="mt-3 btn w-75" type="button" [routerLink]="'/login'">Back to Login</button>
    </div>
</section>